export const LUMPSUM_PLANS_API_RETRY_COUNT = 1

type LumpsumQueryStatus = {
  isLoading: boolean
  isError: boolean
  isFetching: boolean
}

export function isLumpsumQueryLoading(query: LumpsumQueryStatus): boolean {
  return query.isLoading || (query.isError && query.isFetching)
}

export function isLumpsumQueryFetchFailed(query: LumpsumQueryStatus): boolean {
  return query.isError && !query.isFetching
}
